import CanvasPool from '@FreeRider/Utils/CanvasPool';

abstract class Head
{
    protected canvas: HTMLCanvasElement;
    protected canvasCtx: CanvasRenderingContext2D;
    protected drawn: boolean;

    public width: number;
    public height: number;
    public offsetX: number;
    public offsetY: number;
    public scale: number;

    constructor()
    {
        this.canvas = CanvasPool.get();
        this.canvasCtx = this.canvas.getContext('2d');
        this.drawn = false;
    }

    /**
     * Returns the head canvas
     */
    public getCanvas(zoom): HTMLCanvasElement
    {
        if (this.drawn === false)
        {
            this.draw(zoom);
        }

        return this.canvas;
    }

    /**
     * Draws the head to canvas
     */
    public draw(zoom: number): void
    {
        // noop
    }
}

export default Head;